// extracted by mini-css-extract-plugin
export default {"title":"jba-z","warning":"kba-z","sizeOptionsLegendText":"lba-z"};